import React, { useCallback, useState, useEffect } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: '2px 4px',
      display: 'flex',
      alignItems: 'center',
    },
    input: {
      marginLeft: theme.spacing(1),
      flex: 1,
    },
    iconButton: {
      padding: 10,
    },
    divider: {
      height: 28,
      margin: 4,
    },
  })
);

interface SearchBoxProps {
  label?: string;
  onSearch?: (search: string) => any;
  defautlValue?: string;
}

export default function SearchBox({
  label = 'Search Deals',
  onSearch = null,
  defautlValue = '',
}: SearchBoxProps) {
  const classes = useStyles();
  const [value, setValue] = useState(defautlValue || '');

  useEffect(() => {
    setValue(defautlValue || '');
  }, [defautlValue]);

  const keyDownSubmit = useCallback(
    (evt: React.KeyboardEvent<HTMLInputElement>) => evt.key === 'Enter' && onSearch(value),
    [value, onSearch]
  );

  return (
    <Paper className={classes.root}>
      <InputBase
        className={classes.input}
        placeholder={label}
        value={value || ''}
        onChange={e => setValue(e.target.value)}
        inputProps={{ 'aria-label': 'search google maps' }}
        onKeyPress={onSearch && keyDownSubmit}
      />
      <IconButton
        onClick={onSearch && (() => onSearch(value))}
        className={classes.iconButton}
        aria-label="search">
        <SearchIcon />
      </IconButton>
    </Paper>
  );
}
